// import node module libraries
import { Fragment } from "react";

// import sub components
import FilesTable from "./FilesTable";

const ConvolFiles = () => {
  return (
    <Fragment>
      {/* files listing table */}
      <FilesTable />
    </Fragment>
  );
};

export default ConvolFiles;
